import React, { useEffect, useRef, useState } from "react";
import CommonForm from "../../../../../components/commonform/commonForm";
import { EmailValidate } from "../../../../../components/formValidate";
import TextEditer from "../../../../../components/inputs/texteditor";
import Snackbar from "../../../../../components/snackbar/snackbar";
import { is_email_registered, user_profile } from "../../../user.api";
import moment from "moment";
import Swal from "sweetalert2";
let reuired = [
  "company_name",
  "person_name",
  "address",
  "email",
  "abstract_project_proposal",
  "upload_proposal",
  // "logo"
];
let flag = false;
export default function BasicDetails(props) {
  const [formData, setFormData] = useState(props.formData);

  const [keyvalue, setKeyvalue] = useState(0);
  const [count, setCount] = useState(1);
  const [error, setError] = useState({});
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [selectedFile, setSelectedFile] = React.useState(null);
  const fileInputRef = useRef(null);
  const [fileInputKey, setFileInputKey] = useState(Date.now());
  const [isLoggedIn, setIsLoggedIn] = useState(props.state?.isUserAuthenticated || false);

  useEffect(() => {
    if (isLoggedIn && !props.update) {
      user_profile().then((res) => {
        if (res.success && res.data) {
          const profile = res.data;
          setFormData((prev) => ({
            ...prev,
            person_name: profile.name || prev.person_name,
            email: profile.email || prev.email,
            mobile_number: profile.mobile_number || prev.mobile_number,
          }));
        }
      });
    }
  }, [isLoggedIn, props.update]);
  const currentYear = moment().year();
  const startYear = new Date().getMonth() >= 3 ? currentYear : currentYear - 1;

  const financialYears = [
    `${startYear}-${startYear + 1}`,
    `${startYear - 1}-${startYear}`,
    `${startYear - 2}-${startYear - 1}`,
  ];

  const monthIndex = moment().month(); // 0-based, Apr=3
  const fyStart = monthIndex >= 3 ? currentYear : currentYear - 1;
  const currentFY = `${fyStart}-${fyStart + 1}`;

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      financial_records: Array.isArray(prev?.financial_records)
        ? prev.financial_records
        : [{
          financial_year: "",
          fy_turnover: "",
          capital_investment: "",
          total_capital_investment: "",
          remarks: "",
          male_onboarded: "",
          female_onboarded: "",
          genderqueer_onboarded: "",
          total_onboarded: "",
          sc_st_onboarded: "",
          pwd_onboarded: "",
          dir_employ_male: "",
          dir_employ_female: "",
          dir_employ_others: "",
          dir_employ_sc_st: "",
          dir_employ_pwd: "",
          direct_emp: ""
        }],
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // using fixed options defined above
  // useEffect(() => {
  //   setFormData(props.data);
  // }, [props.data]);
  console.log(formData);
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  const textFieldChange = (e) => {
    if (e.target.name === "email" || e.target.name === "alternate_email") {
      let erroremail = !EmailValidate(e.target.value);

      setError({ ...error, [e.target.name]: erroremail });
    }
    let name = e.target.name;

    let value = e.target.value;
    let data = formData;
    data[name] = value;
    setFormData(data);
    setKeyvalue(keyvalue + 1);
  };
  const addNewProductProfile = (i) => {
    let data = { ...formData };

    data.product_profiles.push({ product_name: "", product_desc: "" });
    setFormData(data);
    setCount(count + 1);
  };
  const RemoveProduct = (i) => {
    let data = { ...formData };
    data.product_profiles.splice(i, 1);
    setCount(data);
    setCount(count + 1);
  };
  const handleMultiChange = (e, i) => {
    let data = { ...formData };

    data.product_profiles[i] = {
      ...data.product_profiles[i],
      [e.target.name]: e.target.value,
    };

    setFormData(data);
  };
  const handleNextSubmit = (e) => {
    e.preventDefault();
    let emailData = { email: formData.email };
    console.log(
      formData,
      emailRegex.test(formData?.email),
      emailRegex.test(formData?.alternate_email)
    );
    // if(formData.Certifications === "Other"){
    //   console.log('1enter')
    //   if(!formData.otherCertification){
    //     console.log('2enter')
    //     setSnackOpen(true);
    //     setSnackMessage("Please choose a valid file");
    //     setIsSnackError(true);
    //   }
    // }
    if (
      emailRegex.test(formData?.email) === true &&
      (emailRegex.test(formData?.alternate_email) ||
        !formData?.alternate_email ||
        formData?.alternate_email === "")
    ) {
      const hasFinancialRecord = formData?.financial_records && formData.financial_records.length > 0 && formData.financial_records.some(rec => rec.financial_year && rec.fy_turnover);
      if (!hasFinancialRecord) {
        setSnackOpen(true);
        setSnackMessage("Please add at least one financial record");
        setIsSnackError(true);
        return;
      }

      if (formData?.financial_records && formData.financial_records.length > 0) {
        for (let i = 0; i < formData.financial_records.length; i++) {
          const rec = formData.financial_records[i];
          const male_val = parseInt(rec.dir_employ_male) || 0;
          const female_val = parseInt(rec.dir_employ_female) || 0;
          const others_val = parseInt(rec.dir_employ_others) || 0;
          const total_val = parseInt(rec.direct_emp) || (male_val + female_val + others_val);
          const sc_st_val = parseInt(rec.dir_employ_sc_st) || 0;
          const pwd_val = parseInt(rec.dir_employ_pwd) || 0;

          const male_ob = parseInt(rec.male_onboarded) || 0;
          const female_ob = parseInt(rec.female_onboarded) || 0;
          const others_ob = parseInt(rec.genderqueer_onboarded) || 0;
          const total_ob = parseInt(rec.total_onboarded) || (male_ob + female_ob + others_ob);
          const sc_st_ob = parseInt(rec.sc_st_onboarded) || 0;
          const pwd_ob = parseInt(rec.pwd_onboarded) || 0;

          if (sc_st_ob + pwd_ob > total_ob) {
            setSnackOpen(true);
            setSnackMessage(`For Financial Year ${rec.financial_year || (i + 1)}, sum of SC/ST and PWD onboarded cannot exceed Total Onboarded (${total_ob})`);
            setIsSnackError(true);
            return;
          }
          if (sc_st_val + pwd_val > total_val) {
            setSnackOpen(true);
            setSnackMessage(`For Financial Year ${rec.financial_year || (i + 1)}, sum of Total SC/ST and Total PWD employees cannot exceed Total Employees (${total_val})`);
            setIsSnackError(true);
            return;
          }
          if (male_val < male_ob) {
            setSnackOpen(true);
            setSnackMessage(`For Financial Year ${rec.financial_year || (i + 1)}, Total Male (${male_val}) must be greater than or equal to Male Onboarded During FY (${male_ob})`);
            setIsSnackError(true);
            return;
          }
          if (female_val < female_ob) {
            setSnackOpen(true);
            setSnackMessage(`For Financial Year ${rec.financial_year || (i + 1)}, Total Female (${female_val}) must be greater than or equal to Female Onboarded During FY (${female_ob})`);
            setIsSnackError(true);
            return;
          }
          if (others_val < others_ob) {
            setSnackOpen(true);
            setSnackMessage(`For Financial Year ${rec.financial_year || (i + 1)}, Total Genderqueer (${others_val}) must be greater than or equal to Genderqueer Onboarded During FY (${others_ob})`);
            setIsSnackError(true);
            return;
          }
          if (total_val < total_ob) {
            setSnackOpen(true);
            setSnackMessage(`For Financial Year ${rec.financial_year || (i + 1)}, Total Employees (${total_val}) must be greater than or equal to Total Onboarded During FY (${total_ob})`);
            setIsSnackError(true);
            return;
          }
          if (sc_st_val < sc_st_ob) {
            setSnackOpen(true);
            setSnackMessage(`For Financial Year ${rec.financial_year || (i + 1)}, Total SC/ST (${sc_st_val}) must be greater than or equal to SC/ST Onboarded During FY (${sc_st_ob})`);
            setIsSnackError(true);
            return;
          }
          if (pwd_val < pwd_ob) {
            setSnackOpen(true);
            setSnackMessage(`For Financial Year ${rec.financial_year || (i + 1)}, Total PWD (${pwd_val}) must be greater than or equal to PWD Onboarded During FY (${pwd_ob})`);
            setIsSnackError(true);
            return;
          }
        }
      }

      if (formData.fe_component && formData.fe_component !== "") {
        const feVal = parseFloat(formData.fe_component) || 0;
        let latestTurnover = 0;
        if (formData.financial_records && formData.financial_records.length > 0) {
          for (const fy of financialYears) {
            const found = formData.financial_records.find(rec => rec.financial_year === fy);
            if (found && found.fy_turnover) {
              latestTurnover = parseFloat(found.fy_turnover) || 0;
              break;
            }
          }
        }
        if (feVal >= latestTurnover) {
          setSnackOpen(true);
          setSnackMessage(`Foreign Exchange (FE) Component must be less than the latest year's turnover (${latestTurnover} Cr)`);
          setIsSnackError(true);
          return;
        }
      }

      if (!props.update) {
        is_email_registered(emailData)
          .then((res) => {
            // setIsActive(false);
            if (
              (formData.upload_proposal !== null &&
                formData.upload_proposal !== undefined &&
                formData.upload_proposal !== "") ||
              (formData.file_name !== null &&
                formData.file_name !== undefined &&
                formData.file_name !== "")
            ) {
              props.action(0, formData);
            } else {
              setSnackOpen(true);
              setSnackMessage("Please choose a valid file");
              setIsSnackError(true);
            }
          })
          .catch((error) => {
            setSnackMessage(error.response.data.message);
            setIsSnackError(true);
            setSnackOpen(true);
            // setIsActive(false);
          });
      } else {
        if (
          (formData.upload_proposal !== null &&
            formData.upload_proposal !== undefined &&
            formData.upload_proposal !== "") ||
          (formData.file_name !== null &&
            formData.file_name !== undefined &&
            formData.file_name !== "")
        ) {
          if (formData?.certification !== "Other") {
            props.action(0, formData);
          } else if (formData?.certification === "Other") {
            if (
              formData?.otherCertification &&
              formData?.otherCertification !== ""
            ) {
              props.action(0, formData);
            } else {
              setSnackOpen(true);
              setSnackMessage("Please Mention the Certification");
              setIsSnackError(true);
            }
          }
        } else {
          setSnackOpen(true);
          setSnackMessage("Please choose a valid file");
          setIsSnackError(true);
        }
      }
    } else {
      setSnackOpen(true);
      setSnackMessage("Please enter a valid email");
      setIsSnackError(true);
    }
  };
  const handleNumberChange = (e) => {
    let data = { ...formData };
    let name = e.target.name;
    let value = e.target.value;
    let newValue = value.replace(/[^0-9]/g, "");
    data = { ...data, [name]: newValue };
    setFormData(data);
  };
  const handleFieldNumberChange = (e) => {
    let data = { ...formData };
    let name = e.target.name;
    let value = e.target.value;
    let newValue = value.replace(/[^0-9.]/g, "");
    newValue = newValue.match(/^\d{0,5}(?:\.\d{0,2})?$/);
    if (newValue) {
      data = { ...data, [name]: newValue[0] };
    }
    setFormData(data);
  };

  const handleEmploymentNumberChange = (e) => {
    let data = { ...formData };
    let name = e.target.name;
    let value = e.target.value;
    let newValue = value.replace(/[^0-9.]/g, "");
    newValue = newValue.match(/^\d{0,4}(?:\.\d{0,2})?$/);
    if (newValue) {
      data = { ...data, [name]: newValue[0] };
    }
    setFormData(data);
  };

  // Financial records helpers
  const openFinancialRecordSwal = async (index = null) => {
    const isEdit = index !== null;
    const rec = isEdit ? formData.financial_records[index] : {
      financial_year: "",
      fy_turnover: "",
      capital_investment: "",
      total_capital_investment: "",
      remarks: "",
      male_onboarded: "",
      female_onboarded: "",
      genderqueer_onboarded: "",
      total_onboarded: "",
      sc_st_onboarded: "",
      pwd_onboarded: "",
      dir_employ_male: "",
      dir_employ_female: "",
      dir_employ_others: "",
      dir_employ_sc_st: "",
      dir_employ_pwd: "",
      direct_emp: ""
    };

    const selectedYears = (formData.financial_records || [])
      .map((r, i) => (i === index ? null : r.financial_year))
      .filter(Boolean);
    const availableYears = financialYears.filter((y) => !selectedYears.includes(y));

    const fyOptions = [
      '<option value="">Select Financial Year</option>',
      ...availableYears.map(year => `<option value="${year}" ${rec.financial_year === year ? 'selected' : ''}>${year}</option>`)
    ];

    const { value: formValues } = await Swal.fire({
      title: `<span style="font-size: 20px; font-weight: 700; color: #0A223D;">${isEdit ? "Edit Financial & Employment Record" : "Add Financial & Employment Record"}</span>`,
      width: "1050px",
      customClass: {
        popup: "swal-financial-popup",
      },
      html:
        "<style>" +
        "  .swal-financial-popup {" +
        "    border-radius: 12px !important;" +
        "    padding: 22px 26px !important;" +
        "  }" +
        "  .swal-scroll-container::-webkit-scrollbar {" +
        "    width: 6px;" +
        "  }" +
        "  .swal-scroll-container::-webkit-scrollbar-track {" +
        "    background: #f1f5f9;" +
        "    border-radius: 4px;" +
        "  }" +
        "  .swal-scroll-container::-webkit-scrollbar-thumb {" +
        "    background: #cbd5e1;" +
        "    border-radius: 4px;" +
        "  }" +
        "  .swal-scroll-container::-webkit-scrollbar-thumb:hover {" +
        "    background: #94a3b8;" +
        "  }" +
        "  .swal-sec-card {" +
        "    background: #ffffff;" +
        "    border: 1px solid #e2e8f0;" +
        "    border-radius: 8px;" +
        "    padding: 16px 20px 8px 20px;" +
        "    margin-bottom: 16px;" +
        "    box-shadow: 0 1px 3px rgba(0,0,0,0.02);" +
        "  }" +
        "  .swal-sec-header {" +
        "    display: flex;" +
        "    align-items: center;" +
        "    justify-content: space-between;" +
        "    padding-bottom: 8px;" +
        "    margin-bottom: 14px;" +
        "    border-bottom: 1.5px solid #e2e8f0;" +
        "  }" +
        "  .swal-sec-title {" +
        "    font-size: 13.5px;" +
        "    font-weight: 700;" +
        "    color: #0A223D;" +
        "    text-transform: uppercase;" +
        "    letter-spacing: 0.5px;" +
        "  }" +
        "  .swal-sec-badge {" +
        "    font-size: 11px;" +
        "    color: #475569;" +
        "    background: #f8fafc;" +
        "    border: 1px solid #e2e8f0;" +
        "    padding: 3px 10px;" +
        "    border-radius: 12px;" +
        "    font-weight: 500;" +
        "  }" +
        "  .swal-field-label {" +
        "    display: flex !important;" +
        "    align-items: flex-end !important;" +
        "    font-size: 12px !important;" +
        "    font-weight: 600 !important;" +
        "    color: #1e293b !important;" +
        "    margin-bottom: 6px !important;" +
        "    min-height: 32px !important;" +
        "    line-height: 1.25 !important;" +
        "  }" +
        "  .swal-req {" +
        "    color: #ef4444;" +
        "    margin-left: 2px;" +
        "    font-weight: bold;" +
        "  }" +
        "  .swal-custom-input, .swal-custom-select {" +
        "    font-size: 13px !important;" +
        "    height: 40px !important;" +
        "    padding: 6px 12px !important;" +
        "    border: 1.5px solid #cbd5e1 !important;" +
        "    border-radius: 6px !important;" +
        "    width: 100% !important;" +
        "    box-sizing: border-box !important;" +
        "    background-color: #ffffff !important;" +
        "    color: #0f172a !important;" +
        "    transition: border-color 0.15s ease, box-shadow 0.15s ease !important;" +
        "  }" +
        "  .swal-custom-input:focus, .swal-custom-select:focus {" +
        "    border-color: #0A223D !important;" +
        "    outline: none !important;" +
        "    box-shadow: 0 0 0 3px rgba(10, 34, 61, 0.12) !important;" +
        "  }" +
        "  .swal-custom-input.swal-calc {" +
        "    background-color: #f8fafc !important;" +
        "    color: #0f172a !important;" +
        "    font-weight: 700 !important;" +
        "    cursor: not-allowed !important;" +
        "    border-color: #94a3b8 !important;" +
        "  }" +
        "  input[type=number]::-webkit-inner-spin-button," +
        "  input[type=number]::-webkit-outer-spin-button {" +
        "    -webkit-appearance: none;" +
        "    margin: 0;" +
        "  }" +
        "  input[type=number] {" +
        "    -moz-appearance: textfield;" +
        "  }" +
        "</style>" +
        '<div class="swal-scroll-container" style="text-align: left; max-height: 72vh; overflow-y: auto; overflow-x: hidden; padding: 4px 14px 10px 4px;">' +
        '  <div class="swal-sec-card">' +
        '    <div class="swal-sec-header">' +
        '      <span class="swal-sec-title">1. Financial Overview</span>' +
        '      <span class="swal-sec-badge" style="color: #ef4444;">* Mandatory Fields</span>' +
        "    </div>" +
        '    <div class="row">' +
        '      <div class="col-md-3 form-group mb-3">' +
        '        <label class="swal-field-label">Financial Year <span class="swal-req">*</span></label>' +
        '        <select id="swal-year" class="swal-custom-select">' +
        fyOptions.join("") +
        "        </select>" +
        "      </div>" +
        '      <div class="col-md-3 form-group mb-3">' +
        '        <label class="swal-field-label">Turnover (₹ Cr) <span class="swal-req">*</span></label>' +
        `        <input id="swal-turnover" type="number" step="0.01" class="swal-custom-input" placeholder="e.g. 12.50" value="${rec.fy_turnover || ""}" ` +
        "          oninput=\"let parts = this.value.replace(/[^0-9.]/g, '').split('.'); parts[0] = parts[0].slice(0, 5); if(parts[1]) parts[1] = parts[1].slice(0, 2); this.value = parts.join('.');\">" +
        "      </div>" +
        '      <div class="col-md-3 form-group mb-3">' +
        '        <label class="swal-field-label">Capital Investment During FY (₹ Cr)</label>' +
        `        <input id="swal-capital" type="number" step="0.01" class="swal-custom-input" placeholder="e.g. 5.00" value="${rec.capital_investment || ""}" ` +
        "          oninput=\"let parts = this.value.replace(/[^0-9.]/g, '').split('.'); parts[0] = parts[0].slice(0, 5); if(parts[1]) parts[1] = parts[1].slice(0, 2); this.value = parts.join('.');\">" +
        "      </div>" +
        '      <div class="col-md-3 form-group mb-3">' +
        '        <label class="swal-field-label">Total Capital Investment (₹ Cr)</label>' +
        `        <input id="swal-total-capital" type="number" step="0.01" class="swal-custom-input" placeholder="e.g. 15.00" value="${rec.total_capital_investment || ""}" ` +
        "          oninput=\"let parts = this.value.replace(/[^0-9.]/g, '').split('.'); parts[0] = parts[0].slice(0, 5); if(parts[1]) parts[1] = parts[1].slice(0, 2); this.value = parts.join('.');\">" +
        "      </div>" +
        '      <div class="col-12 form-group mb-2">' +
        '        <label class="swal-field-label" style="min-height: auto; margin-bottom: 4px;">Remarks (optional)</label>' +
        `        <input id="swal-remark" type="text" class="swal-custom-input" placeholder="Enter remarks" value="${rec.remarks || ""}">` +
        "      </div>" +
        "    </div>" +
        "  </div>" +

        '  <div class="swal-sec-card">' +
        '    <div class="swal-sec-header">' +
        '      <span class="swal-sec-title">2. Onboarded During FY</span>' +
        '      <span class="swal-sec-badge">Male + Female + Genderqueer = Total Onboarded</span>' +
        "    </div>" +
        '    <div class="row">' +
        '      <div class="col-md-3 form-group mb-3">' +
        '        <label class="swal-field-label">Male Onboarded During FY <span class="swal-req">*</span></label>' +
        `        <input id="swal-male-onboarded" type="number" class="swal-custom-input" placeholder="Male count" value="${rec.male_onboarded !== undefined && rec.male_onboarded !== null ? rec.male_onboarded : ""}" ` +
        "          oninput=\"this.value = this.value.replace(/[^0-9]/g, '').slice(0, 6); const m = parseInt(this.value) || 0; const f = parseInt(document.getElementById('swal-female-onboarded').value) || 0; const o = parseInt(document.getElementById('swal-genderqueer-onboarded').value) || 0; document.getElementById('swal-total-onboarded').value = m + f + o;\">" +
        "      </div>" +
        '      <div class="col-md-3 form-group mb-3">' +
        '        <label class="swal-field-label">Female Onboarded During FY <span class="swal-req">*</span></label>' +
        `        <input id="swal-female-onboarded" type="number" class="swal-custom-input" placeholder="Female count" value="${rec.female_onboarded !== undefined && rec.female_onboarded !== null ? rec.female_onboarded : ""}" ` +
        "          oninput=\"this.value = this.value.replace(/[^0-9]/g, '').slice(0, 6); const m = parseInt(document.getElementById('swal-male-onboarded').value) || 0; const f = parseInt(this.value) || 0; const o = parseInt(document.getElementById('swal-genderqueer-onboarded').value) || 0; document.getElementById('swal-total-onboarded').value = m + f + o;\">" +
        "      </div>" +
        '      <div class="col-md-3 form-group mb-3">' +
        '        <label class="swal-field-label">Genderqueer Onboarded During FY <span class="swal-req">*</span></label>' +
        `        <input id="swal-genderqueer-onboarded" type="number" class="swal-custom-input" placeholder="Genderqueer count" value="${rec.genderqueer_onboarded !== undefined && rec.genderqueer_onboarded !== null ? rec.genderqueer_onboarded : ""}" ` +
        "          oninput=\"this.value = this.value.replace(/[^0-9]/g, '').slice(0, 6); const m = parseInt(document.getElementById('swal-male-onboarded').value) || 0; const f = parseInt(document.getElementById('swal-female-onboarded').value) || 0; const o = parseInt(this.value) || 0; document.getElementById('swal-total-onboarded').value = m + f + o;\">" +
        "      </div>" +
        '      <div class="col-md-3 form-group mb-3">' +
        '        <label class="swal-field-label">Total Onboarded During FY <span class="swal-req">*</span></label>' +
        `        <input id="swal-total-onboarded" type="number" class="swal-custom-input swal-calc" placeholder="Auto-calculated" readonly tabindex="-1" value="${rec.total_onboarded !== undefined && rec.total_onboarded !== null ? rec.total_onboarded : ""}">` +
        "      </div>" +
        "    </div>" +
        '    <div style="font-size: 11px; font-weight: 700; color: #64748b; text-transform: uppercase; letter-spacing: 0.5px; margin: 4px 0 10px 0; border-top: 1px dashed #e2e8f0; padding-top: 10px;">' +
        "      Category Breakdown (Onboarded)" +
        "    </div>" +
        '    <div class="row">' +
        '      <div class="col-md-6 form-group mb-2">' +
        '        <label class="swal-field-label" style="min-height: auto; margin-bottom: 4px;">SC/ST Onboarded During FY <span class="swal-req">*</span></label>' +
        `        <input id="swal-scst-onboarded" type="number" class="swal-custom-input" placeholder="SC/ST count" value="${rec.sc_st_onboarded !== undefined && rec.sc_st_onboarded !== null ? rec.sc_st_onboarded : ""}" ` +
        "          oninput=\"this.value = this.value.replace(/[^0-9]/g, '').slice(0, 6);\">" +
        "      </div>" +
        '      <div class="col-md-6 form-group mb-2">' +
        '        <label class="swal-field-label" style="min-height: auto; margin-bottom: 4px;">PWD Onboarded During FY <span class="swal-req">*</span></label>' +
        `        <input id="swal-pwd-onboarded" type="number" class="swal-custom-input" placeholder="PWD count" value="${rec.pwd_onboarded !== undefined && rec.pwd_onboarded !== null ? rec.pwd_onboarded : ""}" ` +
        "          oninput=\"this.value = this.value.replace(/[^0-9]/g, '').slice(0, 6);\">" +
        "      </div>" +
        "    </div>" +
        "  </div>" +

        '  <div class="swal-sec-card">' +
        '    <div class="swal-sec-header">' +
        '      <span class="swal-sec-title">3. Total Employment Details</span>' +
        '      <span class="swal-sec-badge">Total Male + Total Female + Total Genderqueer = Total Employees</span>' +
        "    </div>" +
        '    <div class="row">' +
        '      <div class="col-md-3 form-group mb-3">' +
        '        <label class="swal-field-label">Total Male <span class="swal-req">*</span></label>' +
        `        <input id="swal-male" type="number" class="swal-custom-input" placeholder="Total Male count" value="${rec.dir_employ_male || ""}" ` +
        "          oninput=\"this.value = this.value.replace(/[^0-9]/g, '').slice(0, 6); const m = parseInt(this.value) || 0; const f = parseInt(document.getElementById('swal-female').value) || 0; const o = parseInt(document.getElementById('swal-genderqueer').value) || 0; document.getElementById('swal-direct-emp').value = m + f + o;\">" +
        "      </div>" +
        '      <div class="col-md-3 form-group mb-3">' +
        '        <label class="swal-field-label">Total Female <span class="swal-req">*</span></label>' +
        `        <input id="swal-female" type="number" class="swal-custom-input" placeholder="Total Female count" value="${rec.dir_employ_female || ""}" ` +
        "          oninput=\"this.value = this.value.replace(/[^0-9]/g, '').slice(0, 6); const m = parseInt(document.getElementById('swal-male').value) || 0; const f = parseInt(this.value) || 0; const o = parseInt(document.getElementById('swal-genderqueer').value) || 0; document.getElementById('swal-direct-emp').value = m + f + o;\">" +
        "      </div>" +
        '      <div class="col-md-3 form-group mb-3">' +
        '        <label class="swal-field-label">Total Genderqueer <span class="swal-req">*</span></label>' +
        `        <input id="swal-genderqueer" type="number" class="swal-custom-input" placeholder="Total Genderqueer count" value="${rec.dir_employ_others || ""}" ` +
        "          oninput=\"this.value = this.value.replace(/[^0-9]/g, '').slice(0, 6); const m = parseInt(document.getElementById('swal-male').value) || 0; const f = parseInt(document.getElementById('swal-female').value) || 0; const o = parseInt(this.value) || 0; document.getElementById('swal-direct-emp').value = m + f + o;\">" +
        "      </div>" +
        '      <div class="col-md-3 form-group mb-3">' +
        '        <label class="swal-field-label">Total Employees <span class="swal-req">*</span></label>' +
        `        <input id="swal-direct-emp" type="number" class="swal-custom-input swal-calc" placeholder="Auto-calculated" readonly tabindex="-1" value="${rec.direct_emp || ""}">` +
        "      </div>" +
        "    </div>" +
        '    <div style="font-size: 11px; font-weight: 700; color: #64748b; text-transform: uppercase; letter-spacing: 0.5px; margin: 4px 0 10px 0; border-top: 1px dashed #e2e8f0; padding-top: 10px;">' +
        "      Category Breakdown (Total Employees)" +
        "    </div>" +
        '    <div class="row">' +
        '      <div class="col-md-6 form-group mb-2">' +
        '        <label class="swal-field-label" style="min-height: auto; margin-bottom: 4px;">Total SC/ST <span class="swal-req">*</span></label>' +
        `        <input id="swal-scst" type="number" class="swal-custom-input" placeholder="Total SC/ST count" value="${rec.dir_employ_sc_st || ""}" ` +
        "          oninput=\"this.value = this.value.replace(/[^0-9]/g, '').slice(0, 6);\">" +
        "      </div>" +
        '      <div class="col-md-6 form-group mb-2">' +
        '        <label class="swal-field-label" style="min-height: auto; margin-bottom: 4px;">Total PWD <span class="swal-req">*</span></label>' +
        `        <input id="swal-pwd" type="number" class="swal-custom-input" placeholder="Total PWD count" value="${rec.dir_employ_pwd || ""}" ` +
        "          oninput=\"this.value = this.value.replace(/[^0-9]/g, '').slice(0, 6);\">" +
        "      </div>" +
        "    </div>" +
        "  </div>" +
        "</div>",
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: "Save",
      confirmButtonColor: "#0A223D",
      cancelButtonColor: "#6c757d",
      didOpen: (popup) => {
        if (popup) {
          popup.style.padding = "22px 26px";
          popup.style.borderRadius = "12px";
          const confirmBtn = popup.querySelector(".swal2-confirm");
          const cancelBtn = popup.querySelector(".swal2-cancel");
          if (confirmBtn) {
            confirmBtn.style.minWidth = "120px";
            confirmBtn.style.fontWeight = "600";
            confirmBtn.style.borderRadius = "6px";
          }
          if (cancelBtn) {
            cancelBtn.style.minWidth = "120px";
            cancelBtn.style.fontWeight = "600";
            cancelBtn.style.borderRadius = "6px";
          }
        }
        const numberInputs = Swal.getHtmlContainer().querySelectorAll('input[type="number"]');
        numberInputs.forEach(input => {
          input.addEventListener("wheel", function (e) {
            e.preventDefault();
          }, { passive: false });
        });
      },
      preConfirm: () => {
        const year = (document.getElementById("swal-year").value || "").trim();
        const turnover = document.getElementById("swal-turnover").value;
        if (!year) {
          Swal.showValidationMessage("Please select a financial year");
          return false;
        }
        if (!turnover) {
          Swal.showValidationMessage("Please enter turnover");
          return false;
        }

        const turnoverParts = String(turnover).split(".");
        if (turnoverParts[0] && turnoverParts[0].length > 5) {
          Swal.showValidationMessage("Turnover cannot exceed 5 digits");
          return false;
        }

        const capitalInvestment = document.getElementById("swal-capital")?.value || "";
        if (capitalInvestment) {
          const capitalParts = String(capitalInvestment).split(".");
          if (capitalParts[0] && capitalParts[0].length > 5) {
            Swal.showValidationMessage("Capital investment during FY cannot exceed 5 digits");
            return false;
          }
        }

        const totalCapitalInvestment = document.getElementById("swal-total-capital")?.value || "";
        if (totalCapitalInvestment) {
          const totalCapitalParts = String(totalCapitalInvestment).split(".");
          if (totalCapitalParts[0] && totalCapitalParts[0].length > 5) {
            Swal.showValidationMessage("Total capital investment cannot exceed 5 digits");
            return false;
          }
        }

        const maleOnboarded = document.getElementById("swal-male-onboarded")?.value ?? "";
        const femaleOnboarded = document.getElementById("swal-female-onboarded")?.value ?? "";
        const genderqueerOnboarded = document.getElementById("swal-genderqueer-onboarded")?.value ?? "";
        const scStOnboarded = document.getElementById("swal-scst-onboarded")?.value ?? "";
        const pwdOnboarded = document.getElementById("swal-pwd-onboarded")?.value ?? "";
        const totalOnboarded = document.getElementById("swal-total-onboarded")?.value ?? "";

        if (
          maleOnboarded === "" ||
          femaleOnboarded === "" ||
          genderqueerOnboarded === "" ||
          scStOnboarded === "" ||
          pwdOnboarded === "" ||
          totalOnboarded === ""
        ) {
          Swal.showValidationMessage("Please fill all onboarding fields (Male, Female, Genderqueer, SC/ST, PWD, Total Onboarded During FY)");
          return false;
        }

        const male = document.getElementById("swal-male")?.value ?? "";
        const female = document.getElementById("swal-female")?.value ?? "";
        const genderqueer = document.getElementById("swal-genderqueer")?.value ?? "";
        const sc_st = document.getElementById("swal-scst")?.value ?? "";
        const pwd = document.getElementById("swal-pwd")?.value ?? "";
        const directEmp = document.getElementById("swal-direct-emp")?.value ?? "";

        if (
          male === "" ||
          female === "" ||
          genderqueer === "" ||
          sc_st === "" ||
          pwd === "" ||
          directEmp === ""
        ) {
          Swal.showValidationMessage("Please fill all total employment fields (Total Male, Total Female, Total Genderqueer, Total SC/ST, Total PWD, Total Employees)");
          return false;
        }

        const employmentFields = [
          { label: "Male Onboarded During FY", value: String(maleOnboarded) },
          { label: "Female Onboarded During FY", value: String(femaleOnboarded) },
          { label: "Genderqueer Onboarded During FY", value: String(genderqueerOnboarded) },
          { label: "SC/ST Onboarded During FY", value: String(scStOnboarded) },
          { label: "PWD Onboarded During FY", value: String(pwdOnboarded) },
          { label: "Total Onboarded During FY", value: String(totalOnboarded) },
          { label: "Total Male", value: String(male) },
          { label: "Total Female", value: String(female) },
          { label: "Total Genderqueer", value: String(genderqueer) },
          { label: "Total SC/ST", value: String(sc_st) },
          { label: "Total PWD", value: String(pwd) },
          { label: "Total Employees", value: String(directEmp) },
        ];
        const tooLong = employmentFields.find(
          (f) => f.value.replace(/[^0-9]/g, "").length > 6
        );
        if (tooLong) {
          Swal.showValidationMessage(`${tooLong.label} cannot exceed 6 digits`);
          return false;
        }

        const male_val = parseInt(male) || 0;
        const female_val = parseInt(female) || 0;
        const others_val = parseInt(genderqueer) || 0;
        const total_val = parseInt(directEmp) || 0;
        const sc_st_val = parseInt(sc_st) || 0;
        const pwd_val = parseInt(pwd) || 0;

        const male_ob_val = parseInt(maleOnboarded) || 0;
        const female_ob_val = parseInt(femaleOnboarded) || 0;
        const others_ob_val = parseInt(genderqueerOnboarded) || 0;
        const total_onboarded_val = parseInt(totalOnboarded) || 0;
        const sc_st_onboarded_val = parseInt(scStOnboarded) || 0;
        const pwd_onboarded_val = parseInt(pwdOnboarded) || 0;

        if (sc_st_onboarded_val + pwd_onboarded_val > total_onboarded_val) {
          Swal.showValidationMessage("Sum of SC/ST and PWD onboarded cannot exceed the Total Onboarded During FY");
          return false;
        }

        if (sc_st_val + pwd_val > total_val) {
          Swal.showValidationMessage("Sum of Total SC/ST and Total PWD employees cannot exceed the Total Employees count");
          return false;
        }

        if (male_val < male_ob_val) {
          Swal.showValidationMessage(`Total Male (${male_val}) must be greater than or equal to Male Onboarded During FY (${male_ob_val})`);
          return false;
        }
        if (female_val < female_ob_val) {
          Swal.showValidationMessage(`Total Female (${female_val}) must be greater than or equal to Female Onboarded During FY (${female_ob_val})`);
          return false;
        }
        if (others_val < others_ob_val) {
          Swal.showValidationMessage(`Total Genderqueer (${others_val}) must be greater than or equal to Genderqueer Onboarded During FY (${others_ob_val})`);
          return false;
        }
        if (total_val < total_onboarded_val) {
          Swal.showValidationMessage(`Total Employees (${total_val}) must be greater than or equal to Total Onboarded During FY (${total_onboarded_val})`);
          return false;
        }
        if (sc_st_val < sc_st_onboarded_val) {
          Swal.showValidationMessage(`Total SC/ST (${sc_st_val}) must be greater than or equal to SC/ST Onboarded During FY (${sc_st_onboarded_val})`);
          return false;
        }
        if (pwd_val < pwd_onboarded_val) {
          Swal.showValidationMessage(`Total PWD (${pwd_val}) must be greater than or equal to PWD Onboarded During FY (${pwd_onboarded_val})`);
          return false;
        }

        return {
          financial_year: year,
          fy_turnover: turnover,
          capital_investment: capitalInvestment,
          total_capital_investment: totalCapitalInvestment,
          remarks: (document.getElementById("swal-remark")?.value || "").trim(),
          male_onboarded: maleOnboarded,
          female_onboarded: femaleOnboarded,
          genderqueer_onboarded: genderqueerOnboarded,
          total_onboarded: totalOnboarded,
          sc_st_onboarded: scStOnboarded,
          pwd_onboarded: pwdOnboarded,
          dir_employ_male: male,
          dir_employ_female: female,
          dir_employ_others: genderqueer,
          dir_employ_sc_st: sc_st,
          dir_employ_pwd: pwd,
          direct_emp: directEmp
        };
      }
    });

    if (formValues) {
      setFormData((prev) => {
        const list = Array.isArray(prev.financial_records) ? [...prev.financial_records] : [];
        if (isEdit) {
          list[index] = formValues;
        } else {
          list.push(formValues);
        }
        return { ...prev, financial_records: list };
      });
    }
  };

  const removeFinancialRecord = (idx) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete this financial record?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#0A223D",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, delete it!"
    }).then((result) => {
      if (result.isConfirmed) {
        setFormData((prev) => {
          const list = Array.isArray(prev.financial_records) ? [...prev.financial_records] : [];
          list.splice(idx, 1);
          return { ...prev, financial_records: list };
        });
      }
    });
  };
  const handleCheckChange = (e, item) => {
    flag = false;
    let data = [...props.domainData];

    data[item]["checked"] = e.target.checked;
    //setFormData({ ...formData, any_other_flag: false });
    if (props.domainData) {
      props.domainData.forEach((item) => {
        if (item.checked) flag = true;
      });
    }
    props.setDomain(data);
  };
  const handleValid = () => {
    let flags = false;
    if (props.domainData) {
      props.domainData.forEach((item) => {
        if (item.checked) flags = true;
      });
    }
    return flags;
  };
  const handleOtherChange = (e) => {
    // let data = [...props.domainData];
    // data.forEach((item) => {
    //   item["checked"] = false;
    // });
    //
    // props.setDomain(data);
    setFormData({ ...formData, [e.target.name]: e.target.checked });
  };
  const handleFileChange = (e) => {
    const file = e.target.files && e.target.files[0];
    if (!file) return;

    const size = file.size;
    const ext = file.name.split(".").pop()?.toLowerCase();
    const allowed = ["doc", "docx", "pdf"];

    const clearFields = () => {
      if (e.target.name === "upload_proposal") {
        setFormData({
          ...formData,
          file_name: null,
          upload_proposal: null,
        });
      } else if (e.target.name === "registration_certificate") {
        setFormData({
          ...formData,
          registration_certificate_name: null,
          registration_certificate: null,
        });
      }
    };

    if (!allowed.includes(ext)) {
      setSnackMessage("File should be in .doc / .docx / .pdf format");
      setIsSnackError(true);
      setSnackOpen(true);
      clearFields();
      return;
    }

    const mb = size / Math.pow(1024, 2);
    if (mb >= 5) {
      setSnackMessage("File size is greater than 5MB");
      setIsSnackError(true);
      setSnackOpen(true);
      clearFields();
      return;
    }

    // Valid file: update correct fields based on input name
    if (e.target.name === "upload_proposal") {
      setFormData({
        ...formData,
        file_name: file.name,
        upload_proposal: file,
      });
    } else if (e.target.name === "registration_certificate") {
      setFormData({
        ...formData,
        registration_certificate_name: file.name,
        registration_certificate: file,
      });
    } else {
      // Fallback: generic assign to support any future file inputs
      setFormData({
        ...formData,
        [e.target.name]: file,
      });
    }
  };

  const handleImgFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const size = file.size;
    const type = file.name.split(".").pop().toLowerCase();
    const maxMB = 1;
    const fileSizeMB = size / (1024 * 1024);

    const isValidType = ["jpg", "jpeg", "png"].includes(type);

    if (!isValidType) {
      showError("File should be in .png / .jpeg / .jpg format");
      resetFileInput();
      return;
    }

    if (fileSizeMB > maxMB) {
      showError("File size is greater than 1MB");
      resetFileInput();
      return;
    }

    // valid
    setFormData({
      ...formData,
      logo_name: e.target.files[0].name,
      logo: e.target.files[0],
    });
  };

  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    // if (!flag) {
    //   handleEventList();
    // }
  };
  useEffect(() => {
    setFormData({
      ...props.formData,
      // any_other_domain:
      //   props.formData.any_other_flag === 1 ||
      //   props.formData.any_other_flag === "1"
      //     ? props.formData.any_other_domain
      //       ? props.formData.any_other_domain
      //       : ""
      //     : "",
    });

    if (!formData.product_profiles) {
      setFormData({
        ...formData,
        product_profiles: [{ product_name: "", product_desc: "" }],
      });
    }
    setCount(count + 1);
  }, [props.formData]);
  const handleProductDesc = (val, i) => {
    console.log(val);
    console.log(i);
    let data = { ...formData };

    data.product_profiles[i] = {
      ...data.product_profiles[i],

      product_desc: val,
    };

    setFormData(data);
    setCount(count + 1);
  };
  const handleOtherCertificationChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  console.log(formData);

  const showSnackbar = (message) => {
    setSnackMessage(message);
    setIsSnackError(true);
    setSnackOpen(true);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const showError = (message) => {
    setSnackMessage(message);
    setIsSnackError(true);
    setSnackOpen(true);
  };

  const resetFileInput = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = null;
    }
    setFormData((prev) => ({
      ...prev,
      logo: null,
      logo_name: null,
    }));
    setFileInputKey(Date.now());
  };
  return (
    <div className="">
      <form onSubmit={handleNextSubmit}>
        {/* Company Details Section */}
        <div className="form-sections">
          <div className="section-header">
            <h4 className="section-title">Company Details</h4>
            <hr className="section-divider" />
          </div>
          <div className="section-content">
            <CommonForm
              fieldType="text"
              label="Company Name (as per registration/CIN)"
              required
              name="company_name"
              disabled={props.edit}
              value={formData.company_name ?? ""}
              onChange={(e) => {
                textFieldChange(e);
              }}
              {...props}
            />

            <CommonForm
              fieldType="text"
              label="Registration/CIN Number"
              required
              name="cin_number"
              value={formData.cin_number ?? ""}
              onChange={(e) => {
                textFieldChange(e);
              }}
              {...props}
            />

            <CommonForm
              fieldType="file"
              label="Registration Certificate ( .doc / .docx / .pdf format)"
              name="registration_certificate"
              id="registration_certificate"
              accept=".pdf,.jpg,.jpeg,.png"
              fileName={formData.registration_certificate_name}
              onChange={handleFileChange}
              {...props}
            />

            <CommonForm
              fieldType="multiline"
              label="Corporate/Registered Address"
              required
              name="address"
              value={formData.address ?? ""}
              onChange={(e) => {
                textFieldChange(e);
              }}
              {...props}
            />

            <CommonForm
              fieldType="text"
              label="Contact Person Name"
              required
              name="person_name"
              disabled={isLoggedIn}
              value={formData.person_name ?? ""}
              onChange={(e) => {
                textFieldChange(e);
              }}
              {...props}
            />

            <CommonForm
              fieldType="text"
              label="Designation"
              required
              name="person_designation"
              value={formData.person_designation ?? ""}
              onChange={(e) => {
                textFieldChange(e);
              }}
              {...props}
            />

            <CommonForm
              fieldType="email"
              label="Email Id (Primary Contact)"
              error={error.email}
              required
              disabled={props.edit || isLoggedIn}
              name="email"
              value={formData.email ?? ""}
              onChange={(e) => {
                textFieldChange(e);
              }}
              {...props}
            />

            <CommonForm
              fieldType="text"
              label="Contact No (Primary Contact)"
              error={error.mobile_number}
              required
              disabled={true}
              name="mobile_number"
              value={formData.mobile_number ?? ""}
              {...props}
            />

            <label className="control-label mylabel mb-2">Alternate Phone</label>
            <div className="d-flex col-12 align-items-end ">
              <div className="col-1 ">
                <CommonForm
                  fieldType="text"
                  error={error.country_code}
                  name="country_code"
                  maxLength="4"
                  value={formData.country_code ?? ""}
                  onChange={(e) => {
                    handleNumberChange(e);
                  }}
                  {...props}
                />
              </div>
              <div className="p-1"></div>
              <div className="col-11">
                <CommonForm
                  fieldType="text"
                  error={error.alternate_phone}
                  name="alternate_phone"
                  maxLength="10"
                  value={formData.alternate_phone ?? ""}
                  onChange={(e) => {
                    handleNumberChange(e);
                  }}
                  {...props}
                />
              </div>
            </div>

            <CommonForm
              fieldType="email"
              label="Alternate Email"
              error={error.alternate_email}
              name="alternate_email"
              value={
                formData.alternate_email && formData.alternate_email !== "null"
                  ? formData.alternate_email
                  : ""
              }
              onChange={(e) => {
                textFieldChange(e);
              }}
              {...props}
            />

            <CommonForm
              fieldType="text"
              label="Website Link"
              name="site_link"
              value={formData.site_link ?? ""}
              onChange={(e) => {
                textFieldChange(e);
              }}
              {...props}
            />

            <CommonForm
              key={fileInputKey}
              ref={fileInputRef}
              fieldType="file"
              name="logo"
              {...props}
              id="logo"
              fileName={formData.logo_name}
              label="Upload Company Logo"
              accept=".jpg,.jpeg,.png"
              type="file"
              variant="outlined"
              onChange={handleImgFileChange}
              className={"mb-2"}
            />

            <CommonForm
              fieldType="multiline"
              label="Abstract Company Profile (2–4 lines summary)"
              required
              name="abstract_project_proposal"
              value={formData.abstract_project_proposal ?? ""}
              onChange={(e) => {
                textFieldChange(e);
              }}
              {...props}
            />
          </div>
        </div>

        {/* Product Profile Section */}
        <div className="form-sections">
          <div className="section-header">
            <h4 className="section-title">Product Profile(s)</h4>
            <hr className="section-divider" />
          </div>
          <div className="section-content">
            {formData.product_profiles?.map((e, i) => (
              <div key={i} className="product-item">
                <div className="product-header">
                  <h5>Product {i + 1}</h5>
                </div>
                <CommonForm
                  fieldType="text"
                  label="Product Name"
                  required
                  name="product_name"
                  value={e?.product_name}
                  onChange={(e) => {
                    handleMultiChange(e, i);
                  }}
                  {...props}
                />
                <TextEditer
                  label="Product Description (1–3 sentences: function & application)"
                  required
                  name="product_desc"
                  value={e?.product_desc}
                  keyValue={i}
                  key={i + 1}
                  onChange={handleProductDesc}
                  {...props}
                />
                <div className="product-actions">
                  {formData.product_profiles.length === i + 1 && (
                    <button
                      type="button"
                      className="btn btn-primary btn-sm"
                      onClick={(e) => addNewProductProfile(i)}
                    >
                      Add More Product
                    </button>
                  )}
                  {formData.product_profiles.length > 1 && (
                    <button
                      type="button"
                      className="btn btn-outline-danger btn-sm ms-2"
                      onClick={(e) => RemoveProduct(i)}
                    >
                      Remove
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
        {/* Brochure / Leaflet Upload Section */}
        <div className="form-sections">
          <div className="section-header">
            <h4 className="section-title">Brochure / Leaflet Upload</h4>
            <hr className="section-divider" />
          </div>
          <div className="section-content">
            <CommonForm
              fieldType="file"
              required={!formData.file_name ? true : false}
              name="upload_proposal"
              label="Upload Company Brochure/Leaflets"
              {...props}
              id="upload_proposal"
              fileName={formData.file_name}
              accept=".pdf,.docx,.doc"
              type="file"
              variant="outlined"
              onChange={handleFileChange}
            />
            <div className="file-upload-note">
              <small className="text-muted">
                <strong>Note:</strong> Upload only .doc, .docx, .pdf files. Size should be less than 5MB.
                Ensure it includes key capabilities, past projects, etc.
              </small>
            </div>
          </div>
        </div>

        {/* Domain Type Section */}
        <div className="form-sections">
          <div className="section-header">
            <h4 className="section-title">Domain(s) of Activity</h4>
            <hr className="section-divider" />
          </div>
          <div className="section-content">
            <div className="domain-checkboxes">
              {props.domainData &&
                props.domainData.map((item, index) => (
                  <CommonForm
                    key={index}
                    fieldType="checkbox"
                    value={item.checked}
                    required={!formData.any_other_flag && !handleValid()}
                    checked={item.checked}
                    onChange={(e) => handleCheckChange(e, index)}
                    label={item.domain_name}
                    {...props}
                  />
                ))}

              <CommonForm
                fieldType="checkbox"
                onChange={handleOtherChange}
                label="Any Other"
                name="any_other_flag"
                checked={formData.any_other_flag}
                value={formData.any_other_flag}
                {...props}
              />
            </div>
            {formData.any_other_flag && (
              <div className="mt-3">
                <CommonForm
                  fieldType="text"
                  placeholder="Please specify the Domain.."
                  required
                  maxLength={50}
                  name="any_other_domain"
                  value={formData.any_other_domain ?? ""}
                  onChange={(e) => {
                    textFieldChange(e);
                  }}
                  {...props}
                />
              </div>
            )}
          </div>
        </div>
        {/* Financial & Investment Details Section */}
        <div className="form-sections">
          <div className="section-header">
            <h4 className="section-title">Financial & Employment Details</h4>
            <hr className="section-divider" />
          </div>
          <div className="section-content">
            {/* Financial Records Section */}
            <div className="mb-3">
              <div className="d-flex justify-content-between align-items-center mb-3">
                {/* <h5 className="section-title mb-0" style={{ color: "#1C2541" }}>Financial Records</h5> */}
                <></>
                {((formData.financial_records || []).length < 3) && (
                  (() => {
                    const selectedYears = (formData.financial_records || [])
                      .map((r) => r.financial_year)
                      .filter(Boolean);
                    const availableYears = financialYears.filter((y) => !selectedYears.includes(y));
                    return availableYears.length > 0;
                  })()
                ) && (
                    <button
                      type="button"
                      className="btn btn-sm btn-primary"
                      style={{
                        borderRadius: "6px",
                        padding: "8px 16px",
                        fontWeight: "bold",
                        fontSize: "13px",
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "6px",
                        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.08)",
                        border: "none",
                        backgroundColor: "#0A223D"
                      }}
                      onClick={() => openFinancialRecordSwal()}
                    >
                      <i className="fa fa-plus" style={{ fontSize: "12px" }}></i> Add Previous Financial Record
                    </button>
                  )}
              </div>

              <div className="table-responsive shadow-sm rounded border">
                <table className="table table-hover table-striped mb-0 align-middle">
                  <thead style={{ backgroundColor: "#F8F9FA", borderBottom: "2px solid #dee2e6" }}>
                    <tr>
                      <th className="p-3 text-center" style={{ color: "#0A223D", fontWeight: "bold" }}>Financial Year</th>
                      <th className="p-3 text-center" style={{ color: "#0A223D", fontWeight: "bold" }}>Turnover (₹ Cr)</th>
                      <th className="p-3 text-center" style={{ color: "#0A223D", fontWeight: "bold" }}>Capital Investment (₹ Cr)</th>
                      <th className="p-3" style={{ color: "#0A223D", fontWeight: "bold" }}>Onboarded During FY</th>
                      <th className="p-3" style={{ color: "#0A223D", fontWeight: "bold" }}>Total Employment</th>
                      <th className="p-3" style={{ color: "#0A223D", fontWeight: "bold" }}>Remarks</th>
                      {!props.update && <th className="p-3 text-center" style={{ color: "#0A223D", fontWeight: "bold" }}>Actions</th>}
                    </tr>
                  </thead>
                  <tbody>
                    {formData.financial_records && formData.financial_records.length > 0 ? (
                      formData.financial_records.map((rec, idx) => (
                        <tr key={idx}>
                          <td className="p-3 text-center align-middle font-weight-bold text-primary" style={{ fontSize: "15px" }}>
                            {rec.financial_year || "--"}
                          </td>
                          <td className="p-3 text-center align-middle" style={{ fontSize: "14px" }}>
                            {rec.fy_turnover ? (
                              <span className="text-success font-weight-bold">{rec.fy_turnover} Cr</span>
                            ) : "--"}
                          </td>
                          <td className="p-3 text-center align-middle" style={{ fontSize: "13px" }}>
                            <div>
                              <small className="text-muted d-block">During FY:</small>
                              <strong>{rec.capital_investment ? `${rec.capital_investment} Cr` : "--"}</strong>
                            </div>
                            <div className="mt-1">
                              <small className="text-muted d-block">Total:</small>
                              <strong>{rec.total_capital_investment ? `${rec.total_capital_investment} Cr` : "--"}</strong>
                            </div>
                          </td>
                          <td className="p-3 align-middle" style={{ fontSize: "13px" }}>
                            <div className="mb-2">
                              <span className="badge bg-primary text-white mr-2 px-2 py-1" style={{ fontSize: "12px" }}>
                                Total Onboarded: <strong>{rec.total_onboarded || 0}</strong>
                              </span>
                            </div>
                            <div className="mb-2">
                              <span className="badge bg-light text-dark border mr-2 px-2 py-1" style={{ fontSize: "12px" }}>
                                Male: <strong>{rec.male_onboarded || 0}</strong>
                              </span>
                              <span className="badge bg-light text-dark border mr-2 px-2 py-1" style={{ fontSize: "12px" }}>
                                Female: <strong>{rec.female_onboarded || 0}</strong>
                              </span>
                              <span className="badge bg-light text-dark border px-2 py-1" style={{ fontSize: "12px" }}>
                                Genderqueer: <strong>{rec.genderqueer_onboarded || 0}</strong>
                              </span>
                            </div>
                            <div>
                              <span className="badge bg-light text-secondary border mr-2 px-2 py-1" style={{ fontSize: "12px" }}>
                                SC/ST: <strong>{rec.sc_st_onboarded || 0}</strong>
                              </span>
                              <span className="badge bg-light text-secondary border px-2 py-1" style={{ fontSize: "12px" }}>
                                PWD: <strong>{rec.pwd_onboarded || 0}</strong>
                              </span>
                            </div>
                          </td>
                          <td className="p-3 align-middle" style={{ fontSize: "13px" }}>
                            <div className="mb-2">
                              <span className="badge bg-success text-white mr-2 px-2 py-1" style={{ fontSize: "12px" }}>
                                Total Employees: <strong>{rec.direct_emp || 0}</strong>
                              </span>
                            </div>
                            <div className="mb-2">
                              <span className="badge bg-light text-dark border mr-2 px-2 py-1" style={{ fontSize: "12px" }}>
                                Total Male: <strong>{rec.dir_employ_male || 0}</strong>
                              </span>
                              <span className="badge bg-light text-dark border mr-2 px-2 py-1" style={{ fontSize: "12px" }}>
                                Total Female: <strong>{rec.dir_employ_female || 0}</strong>
                              </span>
                              <span className="badge bg-light text-dark border px-2 py-1" style={{ fontSize: "12px" }}>
                                Total Genderqueer: <strong>{rec.dir_employ_others || 0}</strong>
                              </span>
                            </div>
                            <div>
                              <span className="badge bg-light text-secondary border mr-2 px-2 py-1" style={{ fontSize: "12px" }}>
                                Total SC/ST: <strong>{rec.dir_employ_sc_st || 0}</strong>
                              </span>
                              <span className="badge bg-light text-secondary border px-2 py-1" style={{ fontSize: "12px" }}>
                                Total PWD: <strong>{rec.dir_employ_pwd || 0}</strong>
                              </span>
                            </div>
                          </td>
                          <td className="p-3 align-middle text-muted" style={{ fontSize: "13px", maxWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                            {rec.remarks || "--"}
                          </td>
                          {!props.update && (
                            <td className="p-3 text-center align-middle">
                              <div className="d-flex justify-content-center align-items-center gap-2">
                                <button
                                  type="button"
                                  className="btn btn-sm btn-light border text-primary"
                                  style={{
                                    borderRadius: "6px",
                                    padding: "6px 12px",
                                    fontWeight: "500",
                                    fontSize: "13px",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: "6px",
                                    transition: "all 0.2s ease-in-out",
                                    boxShadow: "0 1px 2px rgba(0,0,0,0.05)"
                                  }}
                                  onClick={() => openFinancialRecordSwal(idx)}
                                >
                                  <i className="fa fa-pencil" style={{ fontSize: "12px" }}></i> Edit
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-sm btn-light border text-danger"
                                  style={{
                                    borderRadius: "6px",
                                    padding: "6px 12px",
                                    fontWeight: "500",
                                    fontSize: "13px",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: "6px",
                                    transition: "all 0.2s ease-in-out",
                                    boxShadow: "0 1px 2px rgba(0,0,0,0.05)"
                                  }}
                                  onClick={() => removeFinancialRecord(idx)}
                                >
                                  <i className="fa fa-trash" style={{ fontSize: "12px" }}></i> Delete
                                </button>
                              </div>
                            </td>
                          )}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={props.update ? "6" : "7"} className="text-center py-4 text-muted">
                          <i className="fa fa-info-circle mr-2"></i> No financial records added yet. Click above to add a record.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        {/* Additional Investment & Employment Details Section */}
        <div className="form-sections">
          <div className="section-header">
            <h4 className="section-title">Additional Investment & Employment Details</h4>
            <hr className="section-divider" />
          </div>
          <div className="section-content">
            <CommonForm
              fieldType="text"
              label="Foreign Exchange (FE) Component (if any)"
              name="fe_component"
              value={formData.fe_component ?? ""}
              onChange={(e) => {
                handleEmploymentNumberChange(e);
              }}
              {...props}
            />
          </div>
        </div>

        {/* Achievements & Certifications Section */}
        <div className="form-sections">
          <div className="section-header">
            <h4 className="section-title">Achievements & Certifications</h4>
            <hr className="section-divider" />
          </div>
          <div className="section-content">
            <CommonForm
              fieldType="multiline"
              label="Achievements (briefly list awards, patents, significant contracts)"
              name="achievements"
              value={formData.achievements ?? ""}
              onChange={(e) => {
                textFieldChange(e);
              }}
              {...props}
            />

            <div className="mb-3">
              <label className="control-label mylabel mb-2">Certifications</label>
              <select
                className="form-select"
                name="certification"
                value={formData.certification ?? ""}
                aria-label="Select Certification"
                onChange={(e) => handleOtherCertificationChange(e)}
              >
                <option value="">Select Certification</option>
                <option value="ISO">ISO</option>
                <option value="MSME">MSME</option>
                <option value="KS9100">KS9100</option>
                <option value="ISO9000/2050">ISO9000/2050</option>
                <option value="Z_Certfication">Z Certification</option>
                <option value="Other">Other</option>
              </select>
            </div>

            {formData.certification === "Other" && (
              <div className="mb-3">
                <label htmlFor="otherCertification" className="form-label">Other Certification</label>
                <input
                  type="text"
                  className="form-control"
                  id="otherCertification"
                  name="otherCertification"
                  placeholder="Please specify the certification"
                  value={formData.otherCertification ?? ""}
                  onChange={handleOtherCertificationChange}
                />
              </div>
            )}
          </div>
        </div>
        {/* ///////////////////////////////////// */}
        {/* ///actions ////////////// */}
        <center>
          <div className="footer-buttons-newreg pix">
            <button type="submit" className="primary-btn basic-submit">
              SUBMIT TO PREVIEW
            </button>
          </div>
        </center>
      </form>
      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />
    </div>
  );
}
